/* ------------------- Breadcrumb_comp.jsx ------------------- */
import React from "react";
import "./Breadcrumb_Comp.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const Breadcrumb_Comp = ({ breadcrumbs, additionalClass }) => {
  const navigate = useNavigate();

  // const handleSelect = (href) => {
  //   navigate(href);
  // };

  return (
    <div className={`Breadcrumb_comp ${additionalClass || ""}`.trim()}>
      <ol className="breadcrumb-list">
        {breadcrumbs.map((crumb, idx) => (
          <li
            key={idx}
            className={`breadcrumb-item ${crumb.isActive ? "active" : "home"}`}
            onClick={() => navigate('/')}
          >
            {/* ----- clickable label (non-active) ----- */}
            {crumb.link && !crumb.isActive ? (
              <span
                className="breadcrumb-link"
                onClick={(e) => {
                  e.preventDefault();
                  // handleSelect(crumb.link);
                }}
              >
                {crumb.label}
              </span>
            ) : (
              /* ----- active label ----- */
              <span className="breadcrumb-label">{crumb.label}</span>
            )}

            {/* ----- chevron (only between items) ----- */}
            {idx < breadcrumbs.length - 1 && (
              <FontAwesomeIcon
                className="breadcrumb-chevron"
                icon={faChevronRight}
              />
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};

export default Breadcrumb_Comp;
